import { Reveal } from "./Reveal";
import { MANIFESTO } from "@/data/content";

export const Manifesto = () => (
  <section id="approach" data-testid="manifesto" className="max-w-[1500px] mx-auto px-6 md:px-12 py-28 md:py-40">
    <Reveal className="mb-20 md:mb-28 max-w-3xl">
      <p className="overline text-[#d4af37] mb-6">The Elite Standard</p>
      <h2 className="font-serif font-light text-3xl md:text-5xl leading-tight tracking-tight text-white">
        We built a firm that owners can trust, because we never sit on the other side of the table.
      </h2>
    </Reveal>

    <div className="space-y-px">
      {MANIFESTO.map((c, i) => (
        <Reveal key={c.no} delay={i * 0.08}>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-start border-t border-white/10 py-12 md:py-16">
            <div className="md:col-span-4">
              <span className="font-serif text-7xl md:text-8xl text-white/10 leading-none">{c.no}</span>
            </div>
            <h3 className="md:col-span-4 font-serif text-2xl md:text-3xl text-white leading-snug">
              {c.title}
            </h3>
            <p className="md:col-span-4 text-white/60 font-light leading-relaxed text-base">
              {c.body}
            </p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
